export default "__VITE_ASSET__411baa30__"